<template>
  <div class="full">
    <div class="cg-layer">
      <div class="cg-login-logo-center">
        <a href="https://sites.google.com/view/cell-game/home" target="_blank"><img class="cg-login-logo" src="../img/logo.svg" alt=""></a>
      </div>

      <!--
        <div class="login-with">
          Login with
        </div>
      -->

      <div class="oauth-div">
        <div class="login-row">
          <!-- <img class="color-dots" src="../img/color-dots.svg" alt=""> -->
          <img class="color-dots clickable" @click="googleLogin" src="../img/google-login.svg" alt="">
          <img class="color-dots clickable" @click="twitterLogin" src="../img/login-twitter.svg" alt="">
          <img class="color-dots clickable" @click="facebookLogin" src="../img/facebook-login.svg" alt="">
          <img class="color-dots clickable" @click="emailLogin" src="../img/email.svg" alt="">
          <!-- <img class="color-dots" src="../img/color-dots.svg" alt=""> -->
        </div>
        <div class="center loginwith">
          Login with
        </div>
      </div>

      <div class="bottom-row">

        <div class="center cg-about-us-row">
          <a class="cg-aboutus" target="_aboutcellgame" href="https://sites.google.com/view/cell-game/home">About</a>
        </div>
        <div class="infobox">
          <div class="cg-statsbox">
            <div class="cg-icon-box">
              <div class="cg-icon-left">
                <img src="../img/question.svg" alt="">
              </div>
              <div class="cg-text-right">
                <div class="cg-stats-text">{{ numberQ.toFixed(0) || 0 }}+</div>
                <div class="cg-stats-desc">Questions *</div>
              </div>
            </div>
            <div class="cg-icon-box">
              <div class="cg-icon-left">
                <img src="../img/stats.svg" alt="">
              </div>
              <div class="cg-text-right">
                <div class="cg-stats-text">{{ numberAns.toFixed(0)  || 0 }}+</div>
                <div class="cg-stats-desc">Questions Answered *</div>
              </div>
            </div>
          </div>
          <div class="center cg-disclaimer">
            * Numbers are estimated and around that number. Question are shared across apps and games, may include small amount of testing data. Data is downloaded {{ ago || 'a few moment ago' }}.
          </div>
        </div>
        <div class="cg-follow-us-on-row">
          <div class="cg-follow-us-on center">
            Follow us on
          </div>
          <div class="center">
            <div>
              <a href="https://www.facebook.com/MasterCell0710/" target="_blank">
                <img src="../img/icon-fb.svg" alt="">
              </a>
              <a href="https://twitter.com/the_cell_game" target="_blank">
                <img src="../img/icon-twitter.svg" alt="">
              </a>
              <a href="https://www.instagram.com/palmscellgame/" target="_blank">
                <img src="../img/icon-ig.svg" alt="">
              </a>
            </div>
          </div>

        </div>
      </div>

    </div>
    <transition name="flyin">
      <div v-if="form === 'email'" class="cg-layer blackcloser" @click="form = 'close'">
      </div>
    </transition>
    <transition name="flyin">
    <div v-if="form === 'email'" class="cg-popup">
      <div class="auth-forms" v-if="form === 'email'">
        <form autocomplete="cell-game-reg-reg"  @submit.prevent="register(auth)" v-if="mode === 'register'">
          <!-- <div>
            Register
          </div> -->
          <div class="center">
            <input type="text" class="login-landing-input" autocomplete="cellgame-reg-username"  placeholder="username" v-model="auth.username">
          </div>
          <div class="center">
            <input type="password"  class="login-landing-input" autocomplete="cellgame-reg-password" placeholder="password" v-model="auth.password">
          </div>
          <div class="center">
            <input type="email"  class="login-landing-input" autocomplete="cellgame-reg-email" placeholder="email" v-model="auth.email">
          </div>
        </form>

        <div v-if="mode === 'register'"  class="center-stuff">
          <button class="cg-submit login-landing-button" @click="register(auth)">
            Register
          </button>
          <button class="cg-submit login-landing-button secondary" @click="mode = 'login'">
            Switch to Login
          </button>
          <p style="max-width: 350px;">
            If you used social media to login before,
            the social media email cannot use for personal-email login/register.
            <br/>
            <br/>

            Please use an different email that hasn't been used in social login.
          </p>

        </div>

        <form autocomplete="cell-game-login-first" @submit.prevent="login(auth)" v-if="mode === 'login'">
          <!-- <div class="center">
            Login
          </div> -->
          <div class="center">
            <input type="email" class="login-landing-input" autocomplete="cellgame-login-login-email" placeholder="username" v-model="auth.loginUser">
          </div>
          <div class="center">
            <input type="password" class="login-landing-input" autocomplete="cellgame-login-login-password" placeholder="password" v-model="auth.loginPassword">
          </div>
        </form>

        <div v-if="mode === 'login'" class="center-stuff">
          <button class="cg-submit login-landing-button" @click="login(auth)">
            Login
          </button>
          <button class="cg-submit login-landing-button secondary" @click="mode = 'register'">
            Switch to Register
          </button>
          <p style="max-width: 350px;">

            If you used social media to login before,
            the social media email cannot use for personal-email login/register.
            <br/>
            <br/>
            Please use an different email that hasn't been used in social login.
          </p>
        </div>

        <div v-if="msg" style="max-width: 350px;">
          {{ msg }}
        </div>

        <!-- <button @click="logout()">Logout</button> -->
      </div>

      <transition name="flyin">
        <div v-if="form === 'email'" class="blackcloser-icon" @click="form = 'close'">
          <img src="../img/close.svg" alt="">
        </div>
      </transition>
    </div>
    </transition>

  </div>
</template>

<script>
import TWEEN from '@tweenjs/tween.js'
import * as sAPI from '../api/strapi'

export default {
  data () {
    return {
      overlay: false,
      // pro: sAPI.LS.Profile,
      msg: ``,
      form: 'oauth',
      mode: 'login',
      auth: {
        loginUser: '',
        loginPassword: '',
        username: '',
        email: '',
        password: ''
      },
      ago: false,
      numberQ: 0,
      numberAns: 0
    }
  },
  mounted () {
    this.getQAns()
  },
  methods: {
    async getQAns () {
      let numberQ = await sAPI.getQuestionCounter()
      let numberAns = await sAPI.getRespondCounter()
      this.ago = require('moment')().fromNow()
      numberQ = Math.ceil(numberQ / 100) * 100
      numberAns = Math.ceil(numberAns / 100) * 100

      new TWEEN.Tween(this)
        .to({ numberQ, numberAns }, 5000)
        .start()

      function loop () {
        if (TWEEN.update()) {
          setTimeout(loop)
        }
      }
      loop()
    },
    googleLogin () {
      this.form = 'oauth'
      sAPI.googleLogin()
    },
    emailLogin () {
      this.form = 'email'
    },
    facebookLogin () {
      this.form = 'oauth'
      sAPI.facebookLogin()
    },
    twitterLogin () {
      this.form = 'oauth'
      sAPI.twitterLogin()
    },
    login ({ loginUser, email, loginPassword }) {
      this.msg = ''
      sAPI.login({ identifier: loginUser, password: loginPassword })
        .then(() => {
          this.$emit('ok')
        })
        .catch((e) => {
          console.error(e)
          this.msg = 'Cannot Login, ' + 'same email / username detected for other way to login'
        })
    },
    register ({ username, email, password }) {
      this.msg = ''
      sAPI.register({ username, email, password })
        .then(() => {
          window.alert('successfully registered')
          // this.login(this.auth)
        })
        .catch((e) => {
          console.error(e)
          this.msg = 'Cannot Register, ' + e.message

          // this.login(this.auth)
        })
    },
    logout () {
      sAPI.logout()
    }
  }
}
</script>

<style>
</style>
